import { BuilderConfig } from '../../types/Builder';
import BusinessHubHeroIndustry, { BusinessHubHeroIndustryProps } from './busines-hub-hero-industry';

export const BusinessHubHeroIndustryBuilderConfig = {
    name: 'Business Hub Hero Industry',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: '',
        },

        {
            name: 'content',
            type: 'object',
            subFields: [
                {
                    name: 'title',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'description',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'ctaLink',
                    type: 'string',
                    defaultValue: '',
                },
            ],
        },
        {
            name: 'listImageHero',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    defaultValue: '',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<BusinessHubHeroIndustryProps> = {
    component: BusinessHubHeroIndustry,
    config: BusinessHubHeroIndustryBuilderConfig,
};

export default builderConfig;
